import React, { useEffect, useState } from 'react';
import { ErrorHandler } from '../ErrorHandler';
import { useTranslation } from 'react-i18next';
import { preferencesGroupsStorage } from '../../services/preferencesGroupsStorage';
import PreferenceGroupsListItem from './PreferenceGroupsListItem';

const PreferenceGroupsList = ({ skipLoad = false }) => {
    const { i18n } = useTranslation();
    const [preferenceGroupsListIsChanged, setPreferenceGroupsListIsChanged] = useState(null);

    const changePreferenceGroups = () => {
        setPreferenceGroupsListIsChanged(prev => !prev);
    };

    useEffect(() => {
        if (!skipLoad) {
            preferencesGroupsStorage.loadItems(() => {});
        }
        preferencesGroupsStorage.registerFiltersChangingObserver(changePreferenceGroups);
        changePreferenceGroups();
        return () => {
            preferencesGroupsStorage.unRegisterFiltersChangingObserver(changePreferenceGroups);
            if (!skipLoad) {
                preferencesGroupsStorage.changeSelectedPreferenceGroups('', true);
            }
        };
    }, [skipLoad]);

    return (
        preferencesGroupsStorage.getItems().length && preferenceGroupsListIsChanged !== null ?
            <>
                <ul className="preference__list">
                    {preferencesGroupsStorage.getItems().map((group, index) => (
                        <React.Fragment key={group.id + index}>
                            <PreferenceGroupsListItem group={group}/>
                        </React.Fragment>
                    ))}
                </ul>
            </>
            :
            <ErrorHandler isSmall={true} titleValue={i18n.t('app.page.profile.emptyData')} />
    );
};

export default PreferenceGroupsList;
